import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  forwardRef,
} from '@angular/core';

// import { BusinessDetailComponent } from '../business-detail/business-detail.component';

import { Router } from '@angular/router';

import { OtherService } from 'src/app/services/other.service';

import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

import { MatSnackBar } from '@angular/material/snack-bar';

import { filter, map } from 'rxjs';

import { AccountService } from 'src/app/services/account.service';

declare var bootstrap: any;

@Component({

  selector: 'app-landing-page',

  templateUrl: './landing-page.component.html',

  styleUrls: ['./landing-page.component.css'],

  // providers: [BusinessDetailComponent],
})

export class LandingPageComponent implements OnInit {

  isLogin: boolean;

  ability: any;

  states: any;

  region: any;

  helpTxt: any;

  mobileUser: boolean = false;

  diar_UserInfo: any = {};

  defaultUserCity: any = {};

  list_City: any = [];

  flagsAbbr: string = (<any>window).flagsAbbr;

  strCurrency: string = '';

  obj_Tablighat: any = {};

  bHideTG: boolean = false;

  constructor(

    private router: Router,

    private otherService: OtherService,

    private swUpdate: SwUpdate,

    private snackBar: MatSnackBar,

    private accountService: AccountService,

    private cdr: ChangeDetectorRef

  ) { }

  ngOnInit(): void {

    // this.getHelp(8)

    this.diar_UserInfo.strCityCode = -1

    this.defaultUserCity.strCityCode = -1

    let screenWidth = window.innerWidth;

    if (screenWidth <= 521) this.mobileUser = true;

    this.checkIfVersionUpdated();

    this.otherService.isUserLogin$.subscribe((condition) => {

      this.isLogin = condition;

      if (condition) {
        this.diar_UserInfo = {
          strFullName:
            this.otherService.getLocalStorage().strName +
            ' ' +
            this.otherService.getLocalStorage().strFamily,

          strMobile: this.otherService.getLocalStorage().mobile,

          strCityName: this.otherService.getLocalStorage().cityName,
        };
      }

    });

    this.otherService.isUserSelectedCity$.subscribe((condition) => {

      if (condition) this.defaultUserCity = this.otherService.get_defaultCity();

      // else this.defaultUserCity = {};
      else this.defaultUserCity.strCityCode = -1;

    });

    if (this.isLogin) {

      this.diar_UserInfo = {

        strFullName:

          this.otherService.getLocalStorage().strName + ' ' +

          this.otherService.getLocalStorage().strFamily,

        strMobile: this.otherService.getLocalStorage().mobile,

        strCityName: this.otherService.getLocalStorage().cityName,

        strCityCode: this.otherService.getLocalStorage().CityCode,

      };


    }

    // پنهان کردن آیکون تلگرام در صفحه چت

    this.otherService.isChat_$.subscribe((bHide: boolean) => {

      this.bHideTG = bHide;

      this.cdr.detectChanges();


    })

  }

  // getHelp(e) {
  //   this.accountService.dyarHelp(e).subscribe((response) => {
  //     this.helpTxt = response.toString();
  //   });
  // }

  stepBackToHome() {
    this.router.navigate(['/taxilon/home']);
  }

  changeRoute(path: string) {

    if (!this.isLogin && path != 'home' && path != 'search' && path != 'iranians-hangouts') {

      return this.login(path);

    }

    if (path == 'search') {

      return this.router.navigate([`dyar/search/${this.accountService.tiType_Stored ? this.accountService.tiType_Stored : -1}`]);

    }

    if (path == 'biorhythm') {

      window.open(`/taxilon/${path}`, '_blank')
    }

    if (path == 'support') {

      let myModal = document.getElementById('Fee_Modal');

      var modal = bootstrap.Modal.getInstance(myModal);

      modal?.hide();

    }

    if (path == 'recent-visits') {

      return this.router.navigate(['/taxilon/recent-visits-advertisement'])

    }

    if (path == 'bookmarks-advertisement') {

      return this.router.navigate(['/taxilon/bookmarks-advertisement'])

    }

    this.router.navigate([`/taxilon/${path}`]);

  }

  changeCity(e) {
    // console.log(e);
    var selectedCity = {
      strCityCode: e.CityCode.trim(),

      strCityName: e.strCityName.trim(),
    };

    localStorage.removeItem('dc30al1i7rez0ab02');

    localStorage.setItem(
      'dc30al1i7rez0ab02',
      this.accountService.encrypt(JSON.stringify(selectedCity))
    );

    this.otherService.changeUserSelectedCity_Status(true);
  }

  callOpenSignUpModal() {
    // if (this.businessDetailComponent) {
    //   this.businessDetailComponent.open_SigUpModal();
    // } else {
    //   console.error('BusinessDetailComponent is not available.');
    // }
  }

  login(redirectTo: string) {
    this.router.navigate([`/taxilon/login/${redirectTo}`]);
  }

  logOut() {
    this.otherService.logout();

    this.router.navigate(['/taxilon/home']);
  }

  changeDefault_City(item) {

    var selectedCity = {

      strCityCode: item ? item.CityCode.trim() : -1,

      strCityCodeNew: item ? item.CityCode.trim() : '',

      strCityName: item ? item.strCityName.trim() : ' همه شهر ها ',

    };

    localStorage.removeItem('dc30al1i7rez0ab02');

    localStorage.setItem('dc30al1i7rez0ab02', this.accountService.encrypt(JSON.stringify(selectedCity)));

    this.otherService.changeUserSelectedCity_Status(true);

    // window.location.reload();

    //  آقای جواد این کد رو هیچوقت اضافه نکن این هزار مرتبه

  }

  openloC() {

    var myModal = new bootstrap.Modal(document.getElementById('Modal'), {});

    myModal.show();

  }

  checkIfVersionUpdated() {

    console.log('________________________ Welcome to taxilon  ________________________');

    this.swUpdate.versionUpdates.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'), map((evt) => ({

      type: 'UPDATE_AVAILABLE',

      current: evt.currentVersion,

      available: evt.latestVersion,

    }))).subscribe((evt) => {

      let snack = this.snackBar.open('نسخه جدیدی منتشر شده است !!', 'به روز رسانی', {

        panelClass: ['snackBar-class'],

      }

      );

      snack.onAction().subscribe(() => {

        this.swUpdate.activateUpdate().then(() => {

          document.location.reload();

        });

      });

    });

  }

  openAdd() {
    window.open(
      `dyar/general`,

      '_blank'
    );
  }

  openAbout() {
    window.open(
      `dyar/about`,

      '_blank'
    );
  }



}
